import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getVideoCategories,
  createVideoCategory,
  updateVideoCategory,
  deleteVideoCategory,
  getBreadCrumbInformation,
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import Grid from "../Common/Grid";
import { showSuccessToastMessage, showErrorToastMessage } from "../../../../utilities";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import AdminBreadcrumb from "../Common/Breadcrumb";
import { emptyCheck, isInt } from "../../../../utilities";
import RequiredField from "../Common/RequiredField";

class AdminVideoCategories extends Component {
  state = {
    moduleName: "",
    learningCategoryName: "",
    moduleid: 0,
    jobrolegroupName: "",
    mastervideocategories: [],
    videocategories: [],
    selectedVideoCategory: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: "",
  };
  componentDidMount() {
    // console.log(this.props.match.params);
    this.setState({ moduleid: parseInt(this.props.match.params.moduleid, 10) });
    this.getBreadCrumbInformationFromService();
    this.getVideoCategoriesFromService();
  }
  getBreadCrumbInformationFromService() {
    getBreadCrumbInformation(this.getModuleId(), this.props.match.params.id, null).then((response) => {
      this.setState({ moduleName: response.data.Module, learningCategoryName: response.data.LearningCategory });
    });
  }

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow,
    });
  }
  getVideoCategoriesFromService() {
    this.showSpinner(true);
    let id = 0;
    let isLearning = false;
    if (this.props.learning) {
      id = this.props.match.params.learningid;
      isLearning = true;
    } else {
      id = this.props.match.params.workflowid;
    }
    getVideoCategories(isLearning, this.getModuleId(), id, this.props.match.params.id)
      .then((response) => {
        this.showSpinner(false);
        this.setState({
          videocategories: response.data,
          mastervideocategories: response.data,
        });
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
      });
  }

  editVideoCategory(state) {
    this.setState({
      action: "edit",
      selectedVideoCategory: state,
      showModal: true,
      modalTitle: "Edit Content Category",
      errorMessage: "",
    });
  }

  deleteVideoCategory(state) {
    this.setState({
      action: "delete",
      selectedVideoCategory: state,
      modalDeleteTitle: "Delete Content Category",
      showDeleteModal: true,
    });
  }
  addVideoCategory() {
    const maxOrder =
      this.state.videocategories.length > 0 ? Math.max(...this.state.videocategories.map((o) => o.Order)) : 0;
    let nextOrder = maxOrder + 1;
    this.setState({
      action: "add",
      selectedVideoCategory: { Order: nextOrder },
      showModal: true,
      modalTitle: "Add Content Category",
      errorMessage: "",
    });
  }
  onHideModal() {
    this.setState({
      showModal: false,
    });
  }

  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "Content Category");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  getModuleId() {
    return parseInt(this.props.match.params.moduleid, 10);
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false,
    });
  }
  validate(data) {
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    if (emptyCheck(data.Order)) {
      this.setState({ errorMessage: "Order cannot be blank" });
      return false;
    }
    if (!isInt(data.Order)) {
      this.setState({ errorMessage: "Order only accepts numerical values" });
      return false;
    }
    return true;
  }
  saveVideoCategory() {
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedVideoCategory.Id : 0,
      Name: this.refs["txtVideoCategory"].value,
      Order: this.refs["txtOrder"].value,
      SubCategoryId: this.props.learning ? this.props.match.params.id : 0,
      CategoryId: this.props.learning ? this.props.match.params.learningid : this.props.match.params.workflowid,
      Tid: this.state.action === "edit" ? this.state.selectedVideoCategory.Tid : 0,
    };
    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createVideoCategory(data)
            .then((response) => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getVideoCategoriesFromService();
            })
            .catch((error) => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateVideoCategory(data)
            .then((response) => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getVideoCategoriesFromService();
            })
            .catch((error) => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteVideoCategory() {
    this.showSpinner(true);
    deleteVideoCategory(this.state.selectedVideoCategory.Id)
      .then((response) => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedVideoCategory.Name);
        this.getVideoCategoriesFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleVideoCategoryChange = (event) => {
    let selectedVideoCategory = this.state.selectedVideoCategory;
    selectedVideoCategory.Name = event.target.value;
    this.setState({ selectedVideoCategory: selectedVideoCategory });
  };

  handleSearchTermChange = (event) => {
    let filteredVideoCategories = this.state.mastervideocategories.filter((d) => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        videocategories: filteredVideoCategories,
        searchTerm: event.target.value,
      });
    else
      this.setState({
        videocategories: this.state.mastervideocategories,
        searchTerm: event.target.value,
      });
  };

  manageVideos(videoCategory) {
    // console.log(this.props);
    if (this.props.learning) {
      this.props.history.push(
        `/admin/${this.props.match.params.moduleid}/${this.props.match.params.learningid}/learningvideocategories/${this.props.match.params.id}/videos/${videoCategory.Id}`
      );
    }
    if (this.props.workflow) {
      this.props.history.push(
        `/admin/${this.props.match.params.moduleid}/${this.props.match.params.workflowid}/workflowcategories/videos/${videoCategory.Id}`
      );
    }
  }

  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">
          Content Categories
          {this.state.videocategories.length > 0 && this.props.learning
            ? ` - ${this.state.videocategories[0].SubCategoryName}`
            : ""}
        </h1>

        {this.props.workflow && (
          <AdminBreadcrumb
            data={[
              { name: "Home", link: "/admin/modules/" },
              { name: "Modules", link: "/admin/modules/" },
              {
                name: "Categories",
                link: `/admin/${this.props.match.params.moduleid}/categories/`,
              },
              { name: "Content Categories" },
            ]}
          />
        )}
        {this.props.learning && (
          <AdminBreadcrumb
            data={[
              { name: "Home", link: "/admin/modules/" },
              { name: this.state.moduleName, link: "/admin/modules/" },
              // { name: "Categories", link: `/admin/${this.props.match.params.moduleid}/categories/` },
              {
                name: this.state.learningCategoryName,
                link: `/admin/${this.props.match.params.moduleid}/${this.props.match.params.learningid}/learningcategories/`,
              },
              { name: "Content Categories" },
            ]}
          />
        )}
        <button className="btn btn-default add-btn" onClick={() => this.addVideoCategory()}>
          Add Content Category
        </button>
        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <Grid
          headers={["#", "Name", "Order"]}
          values={this.state.videocategories}
          indexName="Id"
          properties={["Id", "Name", "Order", "Action"]}
          edit={(value) => this.editVideoCategory(value)}
          delete={(value) => this.deleteVideoCategory(value)}
          extraActions={[(value) => this.manageVideos(value)]}
          extraActionNames={["Manage Content"]}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveVideoCategory()}
          form={this.addeditform}
          type="Content Category"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              maxLength="100"
              type="text"
              className="form-control"
              ref="txtVideoCategory"
              defaultValue={this.state.selectedVideoCategory.Name}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Order:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtOrder"
              defaultValue={this.state.selectedVideoCategory.Order}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedVideoCategory.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          modalTitle={this.state.modalDeleteTitle}
          confirm={() => this.confirmDeleteVideoCategory()}
          name={this.state.selectedVideoCategory.Name}
          type="Content Category"
        />
      </Aux>
    );
  }
}

export default AdminVideoCategories;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/VideoCategories/VideoCategories.js